import React from 'react';
import './index.css';
import { FaFilePdf } from "react-icons/fa6";
import { ErrorMessage } from 'formik';

const CustomCheckBox = ({ text, value, setValue, name, shwoPdfOption, checkForCheckoutPage , disabled ,   props }) => {
    const uniqueId = `cbx-${name}`; // Generate a unique id using name

    const handleShowPDF = () => {
        window.open("https://cdn.xs2event.com/generalterms/general-terms-XS2Event_v1.4.pdf", "_blank")
    }

    return (
        <>
            <div className="checkbox-wrapper-46">
                <input
                    type="checkbox"
                    id={uniqueId}
                    className="inp-cbx"
                    name={name}
                    disabled={checkForCheckoutPage || disabled }
                    checked={value}
                    onChange={(e) => setValue(name, e.target.checked)}
                />
                <label htmlFor={uniqueId} className="cbx">
                    <span>
                        <svg viewBox="0 0 12 10" height="10px" width="12px">
                            <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                        </svg>
                    </span>
                    <span className="checkbox_msg">{text} </span>
                </label>
                {shwoPdfOption && <FaFilePdf size="20px" className='pdf_view_booking' color='white' onClick={handleShowPDF} />}
            </div>
            <ErrorMessage name={name} component="div" className="error-message" />
        </>
    );
};

export default CustomCheckBox;
